/**
 * @generated SignedSource<<e8a53db9ff65cca5b194208cf6ca7699>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NewNotificationTemplateButton_AvailableTemplatesFragment$data = {
  readonly Admin: {
    readonly Notification: {
      readonly AvailableSystemTemplates: ReadonlyArray<{
        readonly key: string;
        readonly message: string;
        readonly title: string;
        readonly variables: ReadonlyArray<string>;
      }>;
    };
  };
  readonly " $fragmentType": "NewNotificationTemplateButton_AvailableTemplatesFragment";
};
export type NewNotificationTemplateButton_AvailableTemplatesFragment$key = {
  readonly " $data"?: NewNotificationTemplateButton_AvailableTemplatesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"NewNotificationTemplateButton_AvailableTemplatesFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NewNotificationTemplateButton_AvailableTemplatesFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AdminQueryType",
      "kind": "LinkedField",
      "name": "Admin",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NotificationAdminSchema",
          "kind": "LinkedField",
          "name": "Notification",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NotificationTemplate",
              "kind": "LinkedField",
              "name": "AvailableSystemTemplates",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "key",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "message",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "variables",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "fd285954b83a29880041fadc7de42187";

export default node;
